import { memo, useMemo } from 'react';
import { MultiSelect } from '@upzi/web-shell/custom-components/multi-select';
import { RadioSelect } from '@upzi/web-shell/custom-components/radio-select';
import { ALL_JOB_FILTERS } from '@/services/jobs';
import type {
  JobFilterState,
  JobMultiFilterKey,
  JobSingleFilterKey,
} from '@/services/jobs/model';
import type { JobFilterGroup } from '../filter-config';

type JobFilterControlProps = {
  filters: JobFilterState;
  group: JobFilterGroup;
  onMultiFilterChange: (key: JobMultiFilterKey, value: string[]) => void;
  onSingleFilterChange: (key: JobSingleFilterKey, value: string) => void;
};

const FILTER_DROPDOWN_CONTENT_CLASSNAME =
  'w-[min(20rem,calc(100vw-2rem))] min-w-[min(20rem,calc(100vw-2rem))]';

export const JobFilterControl = memo(function JobFilterControl({
  filters,
  group: { definition, options },
  onMultiFilterChange,
  onSingleFilterChange,
}: JobFilterControlProps) {
  const selectOptions = useMemo(
    () =>
      options.map(option => ({
        value: String(option.id),
        label: option.value,
      })),
    [options]
  );

  if (definition.selectionMode === 'single') {
    return (
      <RadioSelect
        placeholder={definition.label}
        value={filters[definition.stateKey]}
        options={selectOptions}
        emptyValue={ALL_JOB_FILTERS}
        isChip
        showCount={false}
        variant="filter"
        onValueChange={value =>
          onSingleFilterChange(definition.stateKey, value)
        }
        contentClassName={FILTER_DROPDOWN_CONTENT_CLASSNAME}
      />
    );
  }

  return (
    <MultiSelect
      placeholder={definition.label}
      value={filters[definition.stateKey]}
      options={selectOptions}
      isSearch={options.length > 10}
      isChip
      searchPlaceholder="Tìm kiếm"
      variant="filter"
      onValueChange={value => onMultiFilterChange(definition.stateKey, value)}
      contentClassName={FILTER_DROPDOWN_CONTENT_CLASSNAME}
    />
  );
});
